//probs must sum to 1!
export function getRandomIndexFromProbabilityMass(weights) {
  const num = Math.random();
  let s = 0;
  const lastIndex = weights.length - 1;

  for (var i = 0; i < lastIndex; ++i) {
    s += weights[i];
    if (num < s) {
      return i;
    }
  }
  return lastIndex;
}
export function getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min)) + min;
  }



// WEBPACK FOOTER //
// ./src/utils/game-helpers.js